import React from "react";
import { Sparkles, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { clearAuth } from "@/lib/api";
import { setActiveLearner } from "@/lib/learner";

/**
 * Slim top banner that announces "you are in a demo session" on any learner page
 * the visitor lands on via a magic demo link. Renders nothing when the flag
 * isn't set, so it's safe to drop into any learner page unconditionally.
 */
export default function DemoBanner() {
  const nav = useNavigate();
  const active = typeof window !== "undefined" && sessionStorage.getItem("uvc_demo_mode") === "1";
  if (!active) return null;
  const courseTitle = sessionStorage.getItem("uvc_demo_course_title") || "";

  const exit = () => {
    sessionStorage.removeItem("uvc_demo_mode");
    sessionStorage.removeItem("uvc_demo_course_id");
    sessionStorage.removeItem("uvc_demo_course_title");
    clearAuth();
    setActiveLearner(null);
    nav("/login", { replace: true });
  };

  return (
    <div
      className="sticky top-0 z-40 bg-[#222222] text-white border-b border-[#E53935]/40"
      data-testid="demo-mode-banner"
    >
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2.5 text-xs">
          <span className="inline-flex items-center gap-1.5 bg-[#E53935] text-white px-2 py-0.5 rounded-sm font-bold uppercase tracking-wider text-[10px]">
            <Sparkles size={11}/> Demo mode
          </span>
          <span className="text-white/80 truncate hidden sm:inline">
            You&apos;re previewing {courseTitle ? <strong className="text-white">{courseTitle}</strong> : "this course"} as a demo viewer. Quiz attempts &amp; progress here are shared across all demo visitors.
          </span>
          <span className="text-white/80 sm:hidden">Demo session</span>
        </div>
        <button
          onClick={exit}
          className="text-[11px] inline-flex items-center gap-1 text-white/70 hover:text-white border border-white/20 hover:border-white/50 px-2 py-1 rounded transition-colors"
          data-testid="demo-mode-exit"
          title="End the demo session and clear local storage"
        >
          <LogOut size={11}/> Exit demo
        </button>
      </div>
    </div>
  );
}
